import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c1-one-one-one-four',
  templateUrl: './c1-one-one-one-four.component.html',
  styleUrls: ['./c1-one-one-one-four.component.scss']
})
export class C1OneOneOneFourComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion 1/1.1.1_CURRICULUM DELIVERY/1.1.1.4_Lesson Plan.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }
}
